const state = {
	user: {},
	access_token: null,
	client_id: null,
	company:null,
	selected_areas: [],
	excluded_areas: [],
	tobe_deactivated: []
}

const getters = {
	user: state => { return state.user },
	accessToken: state => { return state.access_token },
	clientId: state => { return state.client_id },
	company: state => { return state.company },
	selectedAreas: state => { return state.selected_areas },
	excludedAreas: state => { return state.excluded_areas },
	tobeDeactivated : state => {return state.tobe_deactivated }
}

const mutations = {
	setUser(state, user) {
		state.user = user
	},
	setAccessToken(state, access_token) {
		state.access_token = access_token
	},
	setCompany(state, company){
		state.company = company
	},
	setClientId(state, client_id) {
		state.client_id = client_id
	},
	setSelectedAreas(state, areas) {
		state.selected_areas = areas || [];
	},
	addSelectedArea(state, area) {
		state.selected_areas.push(area)
		console.log('Add Pickups', state.selected_areas);
	},
	removeSelectedArea(state, state_abbr) {
		state.selected_areas = _.filter(state.selected_areas, (next_item) => {
			if(next_item.abbreviation == state_abbr && next_item.filter_set_id){
				state.tobe_deactivated.push(next_item)
				return true;
			}
			return next_item.abbreviation != state_abbr;
		})

		// change filter status
		let index =  _.findIndex(state.selected_areas, (area) => {
			return area.abbreviation == state_abbr
		})
		if(index > -1){
			state.selected_areas[index].status = "Not Active"
		}

		console.log('Remove Pickups', state.selected_areas);
		console.log('To Be Deactivated Pickups', state.tobe_deactivated);
	},
	updateSelectedArea(state, selected_area) {
		let state_abbr = selected_area.abbreviation;
		let index = _.findIndex(state.selected_areas, {abbreviation: state_abbr});
		
		if (index > -1) {
			state.selected_areas[index] = selected_area;
			console.log('Updated Pickup', state.selected_areas);
		}
	},
	setExcludedAreas(state, areas) {
		state.excluded_areas = areas || [];
		console.log('set excluded areas', state.excluded_areas);
		// let new_areas = [] 
		// new_areas = areas.map(area=>{return area.state});
		// console.log(new_areas)
		// state.excluded_areas = new_areas || [];

	},
	// addExcludedArea(state, area) {
	// 	state.excluded_areas.push(excluded_areas)
	// 	console.log('Add Exclusion', state.excluded_areas);
	// },
	// removeExcludedArea(state, index) {
	// 	state.excluded_areas.splice(index, 1)
	// 	console.log('Remove Exclusion', state.excluded_areas);
	// }
}

const actions = {
	addSelectedArea ({commit}, area) {
		// let area = {
		// 	area_code: params.area_code, 
		// 	state: params.state
		// }
		commit('addSelectedArea', area)
	},
	removeAreaCode ({commit, state}, params) {
		var index = state.selected_areas.findIndex(area => { return area.area_code === params.area_code })
		if (index > -1) {
			commit('removeSelectedArea', index)
		}
	},
	fetchAreas({state}) {
		let api_url = process.env.API_URL + '/user/'+state.client_id;
		let params = {
			'token': state.access_token,
			'w': 'pickups, exclusions'
		};

		this.$http.get(api_url, params).then(response => {
			if (response && response.data) {
				state.selected_areas = response.data.selected || [];
				state.excluded_areas = response.data.excluded || [];
			}
		}).catch(error => {
			console.log(error);
		})
	},
	postSelectedAreas({state}) {
		let api_url = process.env.API_URL + '/pickups';
		let params = {
			'token': state.access_token,
			'pickups': state.selected_areas
		};
		
		this.$http.post(api_url, params).then(response => {

		}).catch(error => {
			console.log(error);
		})
	},
	postExcludedAreas({state}) {
		let api_url = process.env.API_URL + '/exclusions';
		let params = {
			'token': state.access_token,
			'exclusions': state.excluded_areas
		};

		this.$http.post(api_url, params).then(response => {

		}).catch(error => {
			console.log(error);
		})
	},
	removeSelectedAreas ({state}) {
		console.log('remove selected areas');
		_.forEach(state.selected_areas, function (area) {
			if(area.polygon){
				area.polygon.setMap(null);
				delete area.polygon;
			}
			if(area.inner_circle){				
				area.inner_circle.setMap(null);
				delete area.inner_circle;
			}
			if(area.inner_inner_circle){
				area.inner_inner_circle.setMap(null);
				delete area.inner_inner_circle;
			}
			if(area.outer_circle){
				area.outer_circle.setMap(null);	
				delete area.outer_circle;
			}
		})
	},
	addExclusionPolygon ({state}, params) {
		console.log('name', params)
		state.excluded_areas.push(params)
	},
	removeExclusionPolygon ({state}, params) {
		console.log('index', params)
		state.excluded_areas.splice(params.index, 1)
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js